export const WILSON_BAR = {
    Z_INDEX: 10000,
    SCRIM_Z_INDEX: 9999,
    TOP_OFFSET: "4vh",
    WIDTH: "85vw",
    FOCUS_DELAY_MS: 50,
    HEIGHT: "90vh",
} as const
